import Api from '../Api';

import { url } from './config';
import { CreditPaymentOption } from './types';

const api = new Api<CreditPaymentOption>(url);

export default api;
